module.exports = __webpack_public_path__ + "img/ssl.57bfb9fe.png";